import React, { Component } from 'react';
import {FormGroup, Label, Input, FormFeedback,
            Col, Alert, Button, ButtonGroup } from 'reactstrap';
import { BarLoader } from 'react-spinners';
import axios from 'axios'
import * as Yup from 'yup'
import { Formik } from 'formik'
import Dropzone from '../../Widgets/Dropzone'
import {toast} from 'react-toastify'
import handleErrorResponseCode from '../../../helpers/error-response-code-handler'
import {WORK_ORDER_UPLOAD_IMAGE_URL} from "../../../redux/config/links"

class UploadPhoto extends Component {

    constructor(props) {
        super(props);
        const {language} = this.props
        this.state = {
            modalDeleteImage: false,
            uploadSuccess: false,
            uploadWAit: false,
            isAdd: true,
            validationObjs : {caption1 : Yup.string().required(`${language.uploadFormImageCaption} 1  ${language.required}`)},
            validations: Yup.object().shape({
                caption1 : Yup.string().required(`${language.uploadFormImageCaption} 1 ${language.required}`)
            }),
            formsAndValues: [{
                "caption": null,
                "imageObj" : null
            }],
        }
    }

    // toggleOpenUpload = () => {

    // }

    // toggleCloseUpload = () => {
    //     this.setState({
    //         modalUpload: !this.state.modalUpload,
    //         validationObjs: null,
    //         validations: null,
    //         formsAndValues: []
    //     })
    // }

    handleOnDrop = (result, index) => { //Dropzone
        const {formsAndValues} = this.state
        let tempFormsAndValues = formsAndValues
        if(result.length === 0) {
            tempFormsAndValues[index]["imageObj"] = null
            this.setState({
                uploadedEvidence: [],
                formsAndValues: tempFormsAndValues
            });
            return;
        }
        if(!result.passed){
            toast.error("Wo image, " + result.reasonRejected)
        }
        tempFormsAndValues[index]["imageObj"] = result
        this.setState({formsAndValues: tempFormsAndValues})
    }

    AddRemoveForm = (props) => {
        let maxFormsBuild = props.uploadLimit
        const MIN_FORM_BUILD = 1
        const {disableAdd, disableRemove, formsAndValues} = this.state
        let currentFormTotal = formsAndValues.length
        return(
            <ButtonGroup>
                <Button  color="primary"
                         onClick={() => this.addForm(currentFormTotal, maxFormsBuild, MIN_FORM_BUILD)}
                         disabled={disableAdd}>
                         <i class="fa fa-plus"></i>
                </Button>
                <Button color="primary" 
                        onClick={() => this.removeForm(currentFormTotal, maxFormsBuild, MIN_FORM_BUILD)}
                        disabled={disableRemove}>
                        <i class="fa fa-minus"></i>
                </Button>
            </ButtonGroup>
        )
    }

    addForm(currentFormTotal, maxForm, minForm){
        const {language} = this.props
        let formsAndValuesTemp = this.state.formsAndValues
        let validationObjsTemp = this.state.validationObjs
        let nexValidationObjText = `${language.uploadFormImageCaption} ${currentFormTotal+1} ${language.required}`
        formsAndValuesTemp.push({
            "caption": null,
            "imageObj" : null
        })
        validationObjsTemp["caption"+Number(currentFormTotal+1)] = Yup.string()
                                                                      .required(nexValidationObjText)

        this.setState({
            formsAndValues: formsAndValuesTemp,
            validationObjs: validationObjsTemp,
            disableAdd : this.checkReachMax(currentFormTotal+1, maxForm),
            disableRemove: this.checkReachMin(currentFormTotal+1, minForm),
        })
        this.updateValidations(validationObjsTemp)
    }

    removeForm(currentFormTotal, maxForm, minForm){
        let formsAndValuesTemp = this.state.formsAndValues
        let validationObjsTemp = this.state.validationObjs
        formsAndValuesTemp.pop()
        delete validationObjsTemp["caption"+currentFormTotal]
        this.setState({
            formsAndValues: formsAndValuesTemp,
            validationObjs: validationObjsTemp,
            disableAdd : this.checkReachMax(currentFormTotal-1, maxForm),
            disableRemove: this.checkReachMin(currentFormTotal-1, minForm),
        })
        this.updateValidations(validationObjsTemp)
    }

    updateValidations(newValidations){
        let updatedValidations = Yup.object().shape(newValidations)
        this.setState({
            validations : updatedValidations
        })
    }

    checkReachMax(currentFormTotal, maxForm){
        if(currentFormTotal === maxForm){
            return true
        }
        return false
    }

    checkReachMin(currentFormTotal, minForm){
        if(currentFormTotal === minForm){
            return true
        } 
        return false
    }

    UploadForm = (props) => {
        const {language} = this.props
        // const MAX_IMAGE = 1
        const MAX_TOTAL_UPLOAD = 2
        const {validations, formsAndValues, isAdd, uploadWAit, uploadSuccess} = this.state
        const {totalWoImage} = this.props
        // let uploadLimit = Number(MAX_IMAGE-totalWoImage)
        return(
            <React.Fragment>
                {/* <Row>
                    <Col xs="12" md="12">
                        <Alert color="info">You can stack up to {uploadLimit} upload forms!</Alert>
                    </Col>
                    <Col xs="12" md="12">
                        <this.AddRemoveForm uploadLimit={uploadLimit}/>
                    </Col>
                </Row>
                <br /> */}
                {totalWoImage+1 <= MAX_TOTAL_UPLOAD?
                <Formik
                onSubmit={(values, { setSubmitting, resetForm}) => {
                    const {formsAndValues} = this.state
                    setSubmitting(true)
                    if(isAdd){
                        Promise.all(formsAndValues.map((obj, index) => {
                            let formDataUploadImage = new FormData();
                            let imageFile = obj["imageObj"]? obj["imageObj"].uploadedFiles[0] : null
                            if(imageFile === null){
                                toast.error("Cannot submit an empty file!")
                                return 1
                            }
                            formDataUploadImage.append('file',imageFile);
                            formDataUploadImage.append('image_desc', `[${ this.props.woNumber}] ${values["caption"+Number(index+1)]}`);
                            formDataUploadImage.append('id_work_order', this.props.idWo);
                            formDataUploadImage.append('customer_sent', 1);
                            axios({
                                    method: 'post',
                                    url: WORK_ORDER_UPLOAD_IMAGE_URL,
                                    data : formDataUploadImage
                                }).then((response) => {
                                    if(response.status === 200){
                                        this.setState({uploadWAit: true})
                                        setTimeout(() => {
                                            this.setState({uploadSuccess : true})
                                            toast.success(`${values["caption"+Number(index+1)]} has been uploaded succesfully!`)
                                        }, 2000);
                                }
                            })
                            .catch(function(error){
                                setSubmitting(false)
                                toast.error(handleErrorResponseCode(error))
                            })
                            return null
                        }))
                        .then(result => {
                            if(result[0] === 1){
                                return
                            }
                            setTimeout(() => {
                                this.props.refreshImage()
                                this.setState({uploadWAit: false})
                                setSubmitting(false)
                            }, 2000);
                        })
                        .catch(function(error){
                            setSubmitting(false)
                            toast.error(error)
                        })
                        // addFormClose()
                    }
                    setSubmitting(false)
                }} 
                validationSchema={validations}
                render={({
                values,errors,
                touched,setFieldValue,
                handleSubmit,handleBlur,
                handleChange,handleReset,
                isValid,isSubmitting,
                }) => (
                    <form>
                        {formsAndValues.map((formAndValue, index) => (
                            <React.Fragment>
                                <FormGroup row>
                                    <Col md="3">
                                        <Label htmlFor="text-input">{language.uploadFormImage}</Label>
                                    </Col>
                                    <Col xs="12" md="9">
                                        <Dropzone maxFile={1} 
                                                maxSize={5000000} //5MB
                                                accept="image/png, image/jpeg" 
                                                onDrop={(result) => this.handleOnDrop(result, index)}
                                                preview={true}
                                                disabled={isSubmitting}>
                                        </Dropzone>
                                    </Col>
                                </FormGroup> 
                                <FormGroup row>
                                    <Col md="3">
                                        <Label htmlFor="text-input">{language.uploadFormImageCaption}</Label>
                                    </Col>
                                    <Col xs="12" md="9">
                                        <Input type="text"
                                            name={"caption"+ Number(index+1)}
                                            id={"caption"+ Number(index+1)}
                                            placeholder={`${language.uploadFormImageCaption} ` + Number(index+1)}
                                            autoComplete={"caption" + Number(index+1)}
                                            valid={!errors["caption"+ Number(index+1)]}
                                            invalid={touched["caption"+ Number(index+1)] && !!errors["caption"+ Number(index+1)]}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values["caption"+ Number(index+1)] || ""}
                                            disabled={isSubmitting}
                                            />
                                    <FormFeedback>{errors["caption"+ Number(index+1)]}</FormFeedback>
                                    </Col>
                                </FormGroup>
                            </React.Fragment>
                        ))}
                           {uploadWAit? 
                                <center>
                                    <BarLoader color={'#123abc'} loading={uploadWAit}/> <br /> {language.pleaseWait} <br /> <br /> 
                                </center>
                                : null
                            }
                            <FormGroup>
                                <Button type="button" 
                                        onClick={handleSubmit} 
                                        color="primary" 
                                        className="mr-1" 
                                        disabled={(isSubmitting || uploadWAit || !isValid)}>{isSubmitting || uploadWAit? 'Wait...' : isAdd? 'Submit' : 'Edit'}
                                </Button>
                                <Button type="button" color="warning" className="mr-1" disabled={isSubmitting || uploadWAit} onClick={() => this.props.toggleCloseUpload(uploadSuccess)}>{language.close}</Button>
                            </FormGroup>
                        </form>
                    )}
                /> :
                <React.Fragment>
                    <Alert color={"warning"}>{language.uploadLimitReach}<br />{language.help}</Alert>
                    <Button type="button" color="warning" className="mr-1" onClick={() => this.props.toggleCloseUpload(uploadSuccess)}>{language.close}</Button>
                </React.Fragment>
                }
            </React.Fragment>
        )
    }

    render(){
        return(
            <React.Fragment>
                <this.UploadForm />
            </React.Fragment>
        )
    }

}

export default UploadPhoto;


// WEBPACK FOOTER //
// ./src/views/Transporter/WOPhotoUpload/UploadPhoto.jsx